import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import axiosCall from '../../../utils/axiosCall';
import DashboardHeader from '../../../components/DashboardComponents/DashboardHeader/DashboardHeader';

const OwnerPackage = () => {
  const [owners, setOwners] = useState<any[]>([]);
  const [packages, setPackages] = useState<any[]>([]);
  const [selectedOwner, setSelectedOwner] = useState('');
  const [selectedPackage, setSelectedPackage] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Fetch owners
    axiosCall.get('/user/all-owners').then((res) => {
      setOwners(res.data?.owners);
      setPackages(res.data?.packages);
    });
  }, []);

  const updatePackage = async () => {
    if (!selectedOwner || !selectedPackage) {
      toast.error('Please select both owner and package');
      return;
    }

    setLoading(true);
    try {
      await axiosCall.post('/packages/update-owner-package', {
        ownerId: selectedOwner,
        packageId: selectedPackage,
      });
      toast.success('Package updated successfully ✅');
    } catch (error) {
      console.error(error);
      toast.error('Failed to update package ❌');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-content">
      <DashboardHeader />
      <div className="">
        <div className="container mt-4">
          <h3>Update Owner Package</h3>
          <div className="row mt-3">
            <div className="col-md-5">
              <label>Owner</label>
              <select
                className="form-control"
                value={selectedOwner}
                onChange={(e) => setSelectedOwner(e.target.value)}
              >
                <option value="">-- Select Owner --</option>
                {owners?.map((l) => (
                  <option key={l._id} value={l._id}>
                    {l.firstName} {l.lastName} ({l.userEmail})
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-5">
              <label>Package</label>
              <select
                className="form-control"
                value={selectedPackage}
                onChange={(e) => setSelectedPackage(e.target.value)}
              >
                <option value="">-- Select Package --</option>
                {packages.map((p) => (
                  <option key={p._id} value={p._id}>
                    {p.name} - ₹{p.monthlyPrice}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-2 d-flex align-items-end">
              <button
                className="btn btn-primary w-100"
                disabled={loading}
                onClick={updatePackage}
              >
                {loading ? 'Updating...' : 'Update'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OwnerPackage;
